/*import {Swiper, Pagination, A11y, Navigation} from 'swiper';*/

import {setSliderCirclesAnimation} from './utils/animations';
import {throttle, fixToIntPixel, loadLibrary} from './modules/Util';
import {LIB_URL} from './App';

const DESKTOP_WIDTH = 1490;
const direction = {
    FORWARD: `FORWARD`,
    BACK: `BACK`,
};
const selectorSlider = {
    bannerMultiple: `.slider-banner--multiple`,
    bannerSingle: `.slider-banner--single`,
    news: `.slider-news`,
    products: `.slider-products`,
    bannerConstructor: `.slider-banner--constructor`,
};

const calculatingWidth = () => window.innerWidth >= DESKTOP_WIDTH;
let isInit = false;
let isDesktopWidth = calculatingWidth();
let sliderNews;

const setMargins = (currentDirection, slides, previousIndex, activeIndex) => {
    for (let i = 0; i < slides.length; i++) {
        slides[i].style.opacity = `1`;
    }
    try{
        if (slides[activeIndex + 3]) slides[activeIndex + 3].style.opacity = `0.3`;
        if (slides[activeIndex - 3]) slides[activeIndex - 3].style.opacity = `0.3`;

        slides[activeIndex + 2].style.opacity = `0.3`;
        slides[activeIndex - 2].style.opacity = `0.3`;
    } catch (err) {
        console.log(err);
    }
};

/*Swiper.use([Pagination, A11y, Navigation]);*/

let sliderAutoplaySpeed = $(selectorSlider.bannerMultiple).data('autoplay') || 9999999;
const multipleBannerSwiper = {
    init: () => loadLibrary(LIB_URL.SWIPER, () => {
        new Swiper(selectorSlider.bannerMultiple, {
            slidesPerView: 1,
            loop: true,
            autoplay: {
              delay: sliderAutoplaySpeed,
              disableOnInteraction: false
            },
            pagination: {
                el: `.slider-banner__pagination`,
                bulletClass: `slider-banner__pagination-item`,
                bulletActiveClass: `slider-banner__pagination-item--active`,
                clickable: true,
            },
            on: {
                init() {
                    setSliderCirclesAnimation(selectorSlider.bannerMultiple, this.activeIndex);
                },
                slideChange() {
                    setSliderCirclesAnimation(selectorSlider.bannerMultiple, this.activeIndex);
                },
                transitionEnd() {
                    fixToIntPixel(this);
                },
            }
        });
    })
};

// Слайдер в больших баннерах на конструкторе
let sliderBnrLoop = !$(this).is('[data-noloop]');
let dynamicBulletsBool = false;
if (App.H.hasClass('page-constructor')) {
    sliderBnrLoop = false;
    dynamicBulletsBool = true;
}
let optionsConstructor = {
    slidesPerView: 1,
    loop: sliderBnrLoop,
    pagination: {
        el: `.slider-banner__pagination`,
        bulletClass: `slider-banner__pagination-item`,
        bulletActiveClass: `slider-banner__pagination-item--active`,
        clickable: true,
        dynamicBullets: dynamicBulletsBool,
    },
    navigation: {
        nextEl: '.slider-banner-next',
        prevEl: '.slider-banner-prev',
    },
    on: {
        init() {
            setSliderCirclesAnimation(selectorSlider.bannerConstructor, this.activeIndex);
        },
        slideChange() {
            setSliderCirclesAnimation(selectorSlider.bannerConstructor, this.activeIndex);
        },
        transitionEnd() {
            fixToIntPixel(this);
        },
    }
};
let constructorBannerSwiper;
if ($(selectorSlider.bannerConstructor).length && $(selectorSlider.bannerConstructor).find('.swiper-slide').length > 1) {
    $(selectorSlider.bannerConstructor).each(function(){
        let sliderDelay = $(this).data('autoplay') || 9999999;

        if($(this).parents('.nizoral-page').length > 0){
            optionsConstructor.loop = true
        }

        optionsConstructor = Object.assign(optionsConstructor, {
            autoplay: {
              delay: sliderDelay,
              disableOnInteraction: false
            }
        });
        constructorBannerSwiper = {
            init: () => loadLibrary(LIB_URL.SWIPER, () => {
                new Swiper(this, optionsConstructor);

                if($(selectorSlider.bannerConstructor).find('.swiper-slide-duplicate')) {
                    $(selectorSlider.bannerConstructor).find('.swiper-slide-duplicate').each(function() {
                        if ($(this).find('h1').length) {
                            const h1 = $(this).find('h1');
                            const attrs = $(this).find('h1')[0].attributes;

                            const div = document.createElement('div');
                            for (let i=0; i<attrs.length; i++) {
                                div.setAttribute(attrs[i].name, attrs[i].value);
                            }
                            $(div).html(h1.html());

                            h1.after(div);
                            h1.remove();
                        };
                    });
                }
            })
        };
        constructorBannerSwiper.init();
    });
}

sliderNews = {
    init: () => loadLibrary(LIB_URL.SWIPER, () => {
        sliderNews.swiper = new Swiper(selectorSlider.news, {
            slidesPerView: `auto`,
            loop: true,
            speed: 300,
            touchRatio: 0.5,
            freeMode: true,
            freeModeSticky: true,
            //freeModeMomentum: false,
            freeModeMomentumRatio: 0.5,
            freeModeMomentumVelocityRatio: 0.1,
            //freeModeMomentumBounce: false,
            freeModeMomentumBounceRatio: 1,
            freeModeMinimumVelocity: 0.02,
            /*spaceBetween: 16,*/
            centeredSlides: true,
            grabCursor: true,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            a11y: {
                prevSlideMessage: `Вперёд`,
                nextSlideMessage: `Назад`,
            },
            on: {
                init() {
                    // if (isDesktopWidth) {
                    //     this.slides[this.activeIndex].style.marginRight = `8px`;
                    //     this.slides[this.activeIndex].style.marginLeft = `-22px`;
                    // }
                },
                slideNextTransitionStart() {
                    //setMargins(direction.FORWARD, this.slides, this.previousIndex, this.activeIndex);
                    isInit = true
                },
                slidePrevTransitionStart() {
                    //setMargins(direction.BACK, this.slides, this.previousIndex, this.activeIndex);
                },
                transitionEnd() {
                    fixToIntPixel(this);
                },
                slideChange() {
                    setMargins(direction.BACK, this.slides, this.previousIndex, this.activeIndex);
                },
                resize() {
                    isDesktopWidth = calculatingWidth();
                }
            }
        });

        setTimeout(() => {
            App.W.on('resized', reinitSliderNews);
        }, 500);
    })
};

function reinitSliderNews() {
    App.W.off('resized', reinitSliderNews);
    sliderNews.swiper.destroy();
    sliderNews.init();
}

App.W.on('load', function () {
    if (App.mobile && App.W.outerWidth() < 768) {
        setSliderNavigationForMobile();
    }
});

// слайдер продуктов на главной
const sliderProductsOptions = {
    slidesPerView: `auto`,
    loop: true,
    pagination: {
        el: `.slider-products__pagination`,
        bulletClass: `slider-products__pagination-item`,
        bulletActiveClass: `slider-products__pagination-item--active`,
        clickable: true,
    },
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
    a11y: {
        prevSlideMessage: `Вперёд`,
        nextSlideMessage: `Назад`,
    },
    spaceBetween: 30,
    centeredSlides: true,
    grabCursor: true,
    breakpoints: {
        768: {
            slidesPerView: 3,
            slidesPerGroup: 3,
        },
        1490: {
            slidesPerView: 4,
            slidesPerGroup: 4,
            centeredSlides: false,
        },
    },
    on : {
        transitionEnd() {
            fixToIntPixel(this);
        },
    }
};

function getSliderOptions(index) {
    let sliderLoop = !$(this).is('[data-noloop]');
    let dynamicBulletsBool = false;
    if (App.H.hasClass('page-constructor')) {
        sliderLoop = false;
        dynamicBulletsBool = true;
    }
     return {
        slidesPerView: `auto`,
        loop: sliderLoop,
        pagination: {
            el: `.slider-products__pagination.slider-products__pagination-${index}`,
            bulletClass: `slider-products__pagination-item`,
            bulletActiveClass: `slider-products__pagination-item--active`,
            clickable: true,
            dynamicBullets: dynamicBulletsBool,
        },
        navigation: {
            nextEl: `.swiper-button-next.swiper-button-next-${index}`,
            prevEl: `.swiper-button-prev.swiper-button-prev-${index}`,
        },
        a11y: {
            prevSlideMessage: `Вперёд`,
            nextSlideMessage: `Назад`,
        },
        spaceBetween: 30,
        centeredSlides: true,
        grabCursor: true,
        breakpoints: {
            768: {
                slidesPerView: 3,
                slidesPerGroup: 3,
            },
            1490: {
                slidesPerView: 4,
                slidesPerGroup: 4,
                centeredSlides: false,
            },
        },
        on : {
            transitionEnd() {
                //console.log('transition change');
                fixToIntPixel(this);
            },
        }
    };
}

const sliderProducts = {init: function() {}};

App.W.on('load', function () {
    setTimeout(function () {
        for (let i = 0; i < $(selectorSlider.products).length; i++) {
            let currOptions = getSliderOptions(i);
            let $currSlider = $(selectorSlider.products).eq(i).closest('.slider');

            $(selectorSlider.products).eq(i).addClass(`slider-products-${i}`);
            $currSlider.find('.slider-products__pagination').addClass(`slider-products__pagination-${i}`);
            $currSlider.find('.swiper-button-prev').addClass(`swiper-button-prev-${i}`);
            $currSlider.find('.swiper-button-next').addClass(`swiper-button-next-${i}`);

            const sliderProductsCount = $currSlider.find('.swiper-slide').length;
            let sliderProductsPerView = getSlidesPerView(currOptions);

            if (sliderProductsCount > 1 && (sliderProductsPerView == 'auto' || sliderProductsPerView < sliderProductsCount)) {
                loadLibrary(LIB_URL.SWIPER, () => {
                    new Swiper(`.slider-products-${i}`, currOptions);
                });
                //console.log('new swiper');
            } else {
                $currSlider.add('_controls-off');
                //document.querySelector(selectorSlider.products) && document.querySelector(selectorSlider.products).classList.add('_controls-off');
            }
        }
    }, 200);
});


//new Swiper(selectorSlider.products, sliderProductsOptions);

function getSlidesPerView(options) {
    if (options.breakpoints) {
        let breakpoints = Object.keys(options.breakpoints).sort((a, b) => {if (+a > +b) return -1; if (+a == +b) return 0; if (+a < +b) return 1;});

        for (let i = 0; i < breakpoints.length; i++) {
            if (window.innerWidth > breakpoints[i]) return options.breakpoints[breakpoints[i]].slidesPerView || 1;
        }
    }
    return options.slidesPerView || 1;
}

function setSliderNavigationForMobile() {
    $('.banner-main--bg-mobile-top').each(function (index, el) {
        const $currSlider = $(el);
        const sliderTopPosition = $currSlider.find('.banner-main__bg-wrap').outerHeight() / 2;

        $currSlider.find('.slider-banner-prev').css({top: `${sliderTopPosition}px`});
        $currSlider.find('.slider-banner-next').css({top: `${sliderTopPosition}px`});
    });
}


export {multipleBannerSwiper, sliderNews, sliderProducts, constructorBannerSwiper};
